export default String.raw`
$(document).ready(()=>{
    if ($('.bannerPromo').length > 0) {
        promotionalBannerFunctions.init();
    }
});

/**
 * Promotional Banner Functions Module
 * Handles slider initialization and banner interaction for promotional banners
 * @module promotionalBannerFunctions
 */
const promotionalBannerFunctions = {
    swiperInstances: {},

    init: function() {
        this.initBannerProductSliders();
        this.setupResizeHandler();
        this.initSearchUrls();
    },

    /**
     * Initialize sliders based on viewport width - mobile only
     */
    initBannerProductSliders: function() {
        
        $(".bannerPromo__swiper").each((i, container) => {
            const $container = $(container);
            const containerId = "bannerSwiper_" + i;

            if (window.innerWidth < 768) {
                if (!this.swiperInstances[containerId]) {
                    this.swiperInstances[containerId] = new Swiper(container, {
                        centerInsufficientSlides: true,
                        spaceBetween: 16,
                        slidesPerView: 1.4,
                        a11y: false,
                        keyboard: {
                            enabled: true,
                            pageUpDown: true
                        },
                        watchSlidesProgress: true,
                        slideToClickedSlide: true,
                        scrollOnFocus: true,
                        on: {
                            init: function () {
                                app.manageTabIndexInsideSlide(this);
                            },
                            slideChangeTransitionEnd: function () {
                                app.manageTabIndexInsideSlide(this);
                            }
                        },
                    });
                }
            } else {
                if (this.swiperInstances[containerId]) {
                    this.swiperInstances[containerId].destroy(true, true);
                    this.swiperInstances[containerId] = null;
                }
                
                $container.find('.swiper-wrapper').removeAttr('style');
                $container.find('.swiper-slide').removeAttr('style');
            }
        });
    },

    initSearchUrls: function() {
        $(".bannerPromo").each((_i, item) => {
            const $item = $(item);
            const filter = $item.data("link");
            
            if (filter) {
            const data = {__action: "Get/SearchAdvanced", tos: "search", flags: filter};
            $.post(null, data, (res) => {
                const url = res.action.Redirect302;
                $item.find(".bannerPromo__header a").attr("href", url);
            });
            }
        });
    },

    setupResizeHandler: function() {
        const self = this;
        let resizeTimeout;
        
        $(window).on('resize', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => self.initBannerProductSliders(), 250);
        });
    }
}
`